export default {
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    articles: 'Artikel',
    spreadsheet: 'Tabelle',
    shoppingGuide: 'Einkaufsführer',
    review: 'Bewertung',
    shipping: 'Versand',
    coupon: 'Gutschein',
    language: 'Sprache',
  },
  footer: {
    about: 'Über AllChinaBuy Spreadsheet',
    links: 'Schnelllinks',
    legal: 'Rechtliches',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    disclaimer: 'Haftungsausschluss',
    copyright: 'AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.',
    description: 'Eine unabhängige Informationsquelle, die Käufern hilft, Produkte, Verkäufer, Versand und Qualitätskontrolle vor der Bestellung zu recherchieren.',
  },
  common: {
    readMore: 'Weiterlesen',
    explore: 'Entdecken',
    buyNow: 'Jetzt kaufen',
    continueToMain: 'Zur Hauptwebsite weitergehen',
    search: 'Suchen',
    breadcrumbHome: 'Startseite',
    close: 'Schließen',
    open: 'Öffnen',
  },
};